import { Injector }                 from '@angular/core';
import {
	BUSINESS_PREMISES_METADATA,
	IBusinessPremisesMetadata
}                                   from '@app/modules/business-premises/config/business-premises.config';
import { BusinessPremises }         from '@app/modules/business-premises/models/business-premises.model';
import {
	businessPremisesActions,
	IBusinessPremisesActions
}                                   from '@app/modules/business-premises/store/business-premises.actions';
import { businessPremisesReducer }  from '@app/modules/business-premises/store/business-premises.reducer';
import { businessPremisesSelector } from '@app/modules/business-premises/store/business-premises.selectors';
import { BusinessPremisesState }    from '@app/modules/business-premises/store/business-premises.state';
import { APP_CONFIG }               from '@appConfig/_app-config_master';
import { AppInjector }              from '@core/services/app-injector.service';
import {
	createEntityAdapter,
	EntityAdapter
}                                   from '@ngrx/entity';
import { LoggerService }            from '@shared/services/logger.service';
import { take }                     from 'rxjs/operators';


class BusinessPremisesStore {
	private readonly businessPremisesMetadata: IBusinessPremisesMetadata = BUSINESS_PREMISES_METADATA;

	private readonly _storeId: string = APP_CONFIG.businesspremises.store.id;

	private _initialState: BusinessPremisesState;

	private _adapter: EntityAdapter<BusinessPremises>;

	private _actions: IBusinessPremisesActions;

	private _selectors;

	private _reducers;

	private _logger: LoggerService;

	get storeId() { return this._storeId; }

	get initialState() { return this._initialState; }

	get reducers() { return this._reducers; }

	get actions() { return this._actions; }

	get selectors() { return this._selectors; }

	constructor() {
		this.init();

		AppInjector.getInjector$()
		.pipe( take( 1 ) )
		.subscribe( ( injector: Injector ) => {
			this._logger = injector?.get( LoggerService );
			this.init();
		} );
	}

	private init(): void {
		this._adapter = createEntityAdapter<BusinessPremises>( {
			selectId: this.selectBusinessPremisesId,
			sortComparer: false
		} );

		this._initialState = {
			adapter: this._adapter.getInitialState(),
			receivedNoEntitiesByApiRequest: true,
			entityActions: {
				create: {
					isEnabled: true,
					showLoader: false
				},
				structureImport: {
					isEnabled: true,
					showLoader: false
				},
				listTssRequest: {
					isEnabled: true,
					showLoader: false
				}
			}
		};

		this._actions = businessPremisesActions( this._storeId );
		this._reducers = businessPremisesReducer( this._storeId, this._initialState, this._adapter, this._logger );
		this._selectors = businessPremisesSelector( this._adapter, this._storeId, this._logger );
	}

	private selectBusinessPremisesId( businessPremises: BusinessPremises ): string {
		return businessPremises.id;
	}
}

export const businessPremisesStore = new BusinessPremisesStore();

